<template>
  <div>
    <pwa-installer></pwa-installer>
    <router-view/>
  </div>
</template>

<style lang="scss">
  /* importo lo stile generale */
  @import "scss/main";
</style>
<script>
  import PwaInstaller from "./components/pwa/Installer";
  export default {
    components: {PwaInstaller}
  }
</script>
